module.exports = __webpack_public_path__ + "static/img/honor15.26dbfea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/honor/honor15.jpg
// module id = dU8S
// module chunks = 1